import {
  Badge,
  Box,
  Button,
  Grid,
  Group,
  Input,
  MultiSelect,
  rem,
  Text,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure, useHotkeys, useIsFirstRender } from "@mantine/hooks";
import {
  IconBuildingSkyscraper,
  IconFileExport,
  IconSearch,
  IconTimeDuration15,
  IconUsersGroup,
} from "@tabler/icons-react";
import { addMonths } from "date-fns";
import dayjs from "dayjs";
import {
  keySearchReportDepartment,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../../_base/component/_layout/_breadcrumb";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_MDM } from "../../../../config";
import { _localization } from "../../../../config/location";
import { MessageResponse } from "../../../../model/MessageResponse";

type ReportPhoneItem = {
  organizationId: number;
  maCn: string;
  departmentId: string | null;
  maBp: string | null;
  tenBp: string | null;
  soLuongGd: number;
  tongDoanhThu: number;
  tongCk: number;
  tongGg: number;
  tongSauCkGg: number;
  tongGiaVon: number;
  tongLaiLo: number;
};
const ReportDepartment = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<ReportPhoneItem[]>([]);
  const [dataSum, setDataSum] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  //Lấy userLoginHeader trong localStorage
  const userLoginHeader = JSON.parse(
    localStorage.getItem("userLoginHeader") || "{}"
  );

  const sizeGrid = { base: 6, sm: 2, md: 2.5, lg: 2.4, xl: 2.4 };

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });

  const firstRender = useIsFirstRender();
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const _searchJson = (() => {
    try {
      const storedValue = sessionStorage.getItem(keySearchReportDepartment);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error("Lỗi khi parse JSON từ sessionStorage:", error);
      return null;
    }
  })();

  const innitStateSearch = React.useMemo(
    () => ({
      keySearch:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.KeySearch
          : "",
      StartTime:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.StartTime
          : new Date(
              new Date(new Date().setHours(0, 0, 0, 0)).getTime() +
                7 * 60 * 60 * 1000
            ).toISOString(),
      EndTime:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.EndTime
          : "",
    }),
    [firstRender, _searchJson]
  );
  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  const [search, setSearch] = useState<{
    MaCn: string[];
    DepartmentId: string[];
    MaBp: string[];
    OrganizationId: string[];
  }>({
    MaCn:
      firstRender && _searchJson && checkedPinSearch ? _searchJson.MaCn : [],
    DepartmentId:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.DepartmentId
        : [],
    MaBp:
      firstRender && _searchJson && checkedPinSearch ? _searchJson.MaBp : [],
    OrganizationId:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.OrganizationId
        : [],
  });
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    // Tạo object keySearch
    const keySearch = {
      Skip: pagination?.pageIndex * pagination.pageSize,
      Take: pagination.pageSize,
      KeySearch: formSeachInput.getValues().keySearch || "",
      StartTime: formSeachInput.getValues().StartTime || "",
      EndTime: formSeachInput.getValues().EndTime || "",
      MaCn: search.MaCn || [],
      DepartmentId: search.DepartmentId || [],
      MaBp: search.MaBp || [],
      OrganizationId: search.OrganizationId || [],
    };

    try {
      // Tạo URL từ keySearch
      let url = `/api/v1/TblOrderHeader/get-list-sales-department-total?`;
      Object.entries(keySearch).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            url += `${key}=${encodeURIComponent(item)}&`;
          });
        } else if (value) {
          url += `${key}=${encodeURIComponent(value)}&`;
        }
      });

      const response = await repositoryMdm.get(url);
      if (response && response.success) {
        const result = response.data;
        setDataSum(result);
      } else {
        setDataSum([]);
        setIsLoading(false);
      }
    } catch (error) {
      setDataSum([]);
      console.error("Error fetching data:", error);
    } finally {
      // Lưu keySearch vào sessionStorage
      sessionStorage.setItem(
        keySearchReportDepartment,
        JSON.stringify(keySearch)
      );
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  const fetchDataSum = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    // Tạo object keySearch
    const keySearch = {
      Skip: pagination?.pageIndex * pagination.pageSize,
      Take: pagination.pageSize,
      KeySearch: formSeachInput.getValues().keySearch || "",
      StartTime: formSeachInput.getValues().StartTime || "",
      EndTime: formSeachInput.getValues().EndTime || "",
      MaCn: search.MaCn || [],
      DepartmentId: search.DepartmentId || [],
      MaBp: search.MaBp || [],
      OrganizationId: search.OrganizationId || [],
    };

    try {
      // Tạo URL từ keySearch
      let url = `/api/v1/TblOrderHeader/get-list-sales-department?`;
      Object.entries(keySearch).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            url += `${key}=${encodeURIComponent(item)}&`;
          });
        } else if (value) {
          url += `${key}=${encodeURIComponent(value)}&`;
        }
      });

      const response = await repositoryMdm.get(url);
      if (response && response.success) {
        const result = response.data;
        setData(result);
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching data:", error);
    } finally {
      // Lưu keySearch vào sessionStorage
      sessionStorage.setItem(
        keySearchReportDepartment,
        JSON.stringify(keySearch)
      );
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  const [dataSaleChannel, setDataBranchCode] = useState<SelectListItemBase[]>(
    []
  );
  const [dataDepartment, setDataDeparment] = useState<SelectListItemBase[]>([]);
  const handleChangeSearchValue = (value: string[] | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : [],
    }));
  };

  const DataBranchCode = async () => {
    try {
      const response = await repositoryPos.get<
        MessageResponse<SelectListItemBase[]>
      >(`api/v1/TblDmInventory/get-select-branch?auth=true`);
      if (response && response.success) {
        const data = response.data;
        setDataBranchCode(data);

        // Tìm `att2` tương ứng với `branchId` từ localStorage
        const branchId = userLoginHeader?.branchId?.toString();
        const matchedBranch = data.find((item) => item.value === branchId);
        if (matchedBranch) {
          setSearch((prev) => ({
            ...prev,
            MaCn: Array.from(
              new Set([...prev.MaCn, matchedBranch.att2.toString()]) // Hợp nhất giá trị
            ),
          }));
        }
        setIsCallFirst(true);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const DataDeparment = async () => {
    try {
      const response = await repositoryPos.get<
        MessageResponse<SelectListItemBase[]>
      >(`/api/v1/TblDepartment/get-select?branchId=0&isShipping=false`);
      if (response && response.success) {
        const data = response.data;
        setDataDeparment(data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const exportDataExcel = async () => {
    open(); // Mở loading
    try {
      let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${
        pagination.pageSize
      }`;

      if (formSeachInput.getValues().keySearch) {
        url += `&KeySearch=${formSeachInput.getValues().keySearch}`;
      }

      if (
        formSeachInput.getValues().StartTime &&
        formSeachInput.getValues().StartTime.length > 0
      ) {
        url += `&StartTime=${formSeachInput.getValues()?.StartTime}`;
      }

      if (
        formSeachInput.getValues().EndTime &&
        formSeachInput.getValues().EndTime.length > 0
      ) {
        url += `&EndTime=${formSeachInput.getValues()?.EndTime}`;
      }

      if (search.MaCn && search.MaCn.length > 0) {
        search.MaCn.forEach((MaCn) => {
          url += `&MaCn=${MaCn}`;
        });
      }

      if (search.DepartmentId && search.DepartmentId.length > 0) {
        search.DepartmentId.forEach((DepartmentId) => {
          url += `&DepartmentId=${DepartmentId}`;
        });
      }

      if (search.MaBp && search.MaBp.length > 0) {
        search.MaBp.forEach((MaBp) => {
          url += `&MaBp=${MaBp}`;
        });
      }

      if (search.OrganizationId && search.OrganizationId.length > 0) {
        search.OrganizationId.forEach((OrganizationId) => {
          url += `&OrganizationId=${OrganizationId}`;
        });
      }

      const baseUrl = `/api/v1/ExportExcel/export-bao-cao-ban-hang-theo-bo-phan${url}`;
      const _url = BASE_API_MDM + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }
      const blob = await response.blob();
      const urlss = window.URL.createObjectURL(blob);
      const _name = new Date().toISOString().slice(0, 10);
      let filename = "bao_cao_ban_hang_theo_bo_phan.xlsx";
      const link = document.createElement("a");
      link.href = urlss;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      close(); // Đóng loading
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<ReportPhoneItem>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      {
        accessorKey: "maBp",
        header: "Mã bộ phận",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            {renderedCellValue === null ? null : (
              <Badge variant="light" color="blue">
                {renderedCellValue}
              </Badge>
            )}
          </>
        ),
      },
      {
        accessorKey: "tenBp",
        header: "Tên bộ phận",
      },
      {
        accessorKey: "maCn",
        header: "Mã chi nhánh",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Badge variant="light" color="violet">
              {renderedCellValue}
            </Badge>
          </>
        ),
        footer: "Tổng:",
        Footer(props) {
          return (
            <div>
              <Text c="red" fw={800}>
                {props.column.columnDef.footer}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "soLuongGd",
        header: "Số lượng giao dịch",
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.soLuongGd || 0),
              0
            );
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalSoLuongGd)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tongDoanhThu",
        header: "Doanh thu",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tongDoanhThu || 0),
              0
            );
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTongDoanhThu)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tongCk",
        header: "Chiết khấu",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tongCk || 0),
              0
            );
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTongCk)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tongGg",
        header: "Giảm giá",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tongGg || 0),
              0
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTongGg)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tongSauCkGg",
        header: "Sau chiết khấu giảm giá",
        size: 200,
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tongSauCkGg || 0),
              0
            );
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTongSauCkGg)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tongGiaVon",
        header: "Giá vốn",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tongGiaVon || 0),
              0
            );
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTongGiaVon)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tongLaiLo",
        header: "Lãi lỗ",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original.tongLaiLo || 0),
              0
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTongLaiLo)}
              </Text>
            </div>
          );
        },
      },
    ],
    [dataSum]
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,

    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT"],
        // right: ["action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableStickyFooter: true,
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    const runAsyncFunctions = async () => {
      await Promise.all([DataBranchCode(), DataDeparment()]);
    };
    const nextuse = async () => {
      await runAsyncFunctions();
    };
    nextuse();
  }, []);

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
      fetchDataSum();
    }
  }, [pagination, isCallFirst]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (160 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  useHotkeys([
    [
      "enter",
      () => {
        fetchData();
        fetchDataSum();
      },
    ],
  ]);

  return (
    <Box pos="relative">
      <LoadingOverlayCustom visible={visible} />
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
        }}
      >
        <Group justify="space-between">
          <BreadcrumbLayout1></BreadcrumbLayout1>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => exportDataExcel()}
            mb={5}
          >
            Export Excel
          </Button>
        </Group>
        <Grid>
          <Grid.Col span={sizeGrid}>
            <Input
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("keySearch")}
              {...formSeachInput.getInputProps("keySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                  fetchDataSum();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Chọn chi nhánh"
              clearable
              searchable
              value={search.MaCn}
              data={dataSaleChannel
                .filter((ele) => ele.att2 && ele.text)
                .map((ele) => ({
                  label: ele.att2 + " - " + ele.text,
                  value: ele.att2,
                }))}
              leftSection={<IconBuildingSkyscraper size={20} color="#15aabf" />}
              onChange={(value) => {
                handleChangeSearchValue(value ? value : null, "MaCn");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Chọn bộ phận"
              clearable
              searchable
              data={dataDepartment
                .filter((ele) => ele.att1 && ele.text)
                .map((ele) => ({
                  label: ele.text,
                  value: ele.value,
                }))}
              value={search.DepartmentId}
              leftSection={<IconUsersGroup size={20} color="#15aabf" />}
              onChange={(value) => {
                handleChangeSearchValue(value ? value : null, "DepartmentId");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              key={formSeachInput.key("StartTime")}
              {...formSeachInput.getInputProps("StartTime")}
              value={
                formSeachInput.getValues().StartTime
                  ? dayjs(formSeachInput.getValues().StartTime).toDate()
                  : null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "StartTime",
                  date
                    ? new Date(
                        new Date(date).getTime() + 7 * 60 * 60 * 1000
                      )?.toISOString()
                    : ""
                )
              }
              clearable
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              key={formSeachInput.key("EndTime")}
              {...formSeachInput.getInputProps("EndTime")}
              maxDate={
                formSeachInput.getValues().StartTime
                  ? addMonths(new Date(formSeachInput.getValues().StartTime), 1)
                  : undefined
              }
              value={
                formSeachInput.getValues().EndTime
                  ? new Date(formSeachInput.getValues().EndTime)
                  : null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "EndTime",
                  date
                    ? new Date(
                        new Date(date).getTime() + 7 * 60 * 60 * 1000
                      )?.toISOString()
                    : ""
                )
              }
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
                await fetchDataSum();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default ReportDepartment;
